module.exports = __webpack_public_path__ + "static/media/FROYO-3Pool.494d523d.png";